import client from "./client";

const getPaymentLinks = () =>
  client.get("/subsidiary/dashboard/payment/link/subsidiary");

export default { getPaymentLinks };
